<template>
  <v-container>
    <h1>Settings</h1>
    <v-row>
      <v-col cols="12" xs="12" md="12" sm="12">
        <v-card>
          <v-card-title>
            <span class="headline">Notification</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" xs="12" sm="6" md="6" class="my-0 py-0">
                <v-textarea
                  name="input-5-1"
                  label="Add Message"
                  v-model="settingModel.addMessage"
                  class="my-0 py-0"
                ></v-textarea>
              </v-col>
              <v-col cols="12" xs="12" sm="6" md="6" class="my-0 py-0">
                <v-textarea
                  name="input-5-1"
                  label="Update Message"
                  v-model="settingModel.updateMessage"
                  class="my-0 py-0"
                ></v-textarea>
              </v-col>
              <v-col cols="12" xs="12" sm="6" md="6" class="my-0 py-0">
                <v-textarea
                  name="input-5-1"
                  label="Delete Message"
                  v-model="settingModel.deleteMessage"
                  class="my-0 py-0"
                ></v-textarea>
              </v-col>
              <!-- <v-col cols="12" xs="12" sm="6" md="6" class="my-0 py-0">
                <v-textarea
                  name="input-5-1"
                  label="Add Unsuccessful Message"
                  v-model="setting.addUnsucMsg"
                  class="my-0 py-0"
                ></v-textarea>
              </v-col>
              <v-col cols="12" xs="12" sm="6" md="6" class="my-0 py-0">
                <v-textarea
                  name="input-5-1"
                  label="Update Unsuccessful Message"
                  v-model="setting.updateUnsucMsg"
                  class="my-0 py-0"
                ></v-textarea>
              </v-col>
              <v-col cols="12" xs="12" sm="6" md="6" class="my-0 py-0">
                <v-textarea
                  name="input-5-1"
                  label="Delete Unsuccessful Message"
                  v-model="setting.deleteUnsucMsg"
                  class="my-0 py-0"
                ></v-textarea>
              </v-col>-->
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <!-- <v-spacer></v-spacer> -->
            <v-btn @click.stop="save" :loading="isSaving" text color="success">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
const API_ENDPOINT = "/api/systemSettings";
import isEmpty from "lodash/isEmpty";
export default {
  data: () => ({
    settingModel: {},
    isSaving: false
  }),
  methods: {
    getSettings() {
      this.$axios
        .get(`${API_ENDPOINT}`)
        .then(({ data }) => {
          if (!isEmpty(data)) this.settingModel = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    save() {
      this.isSaving = true;
      this.$axios
        .post(`${API_ENDPOINT}`, this.settingModel)
        .then(({ data }) => {
          this.$toast.success(data.message);
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    }
  },
  created() {
    this.getSettings();
  }
};
</script>